import EditTableModal from "../../Modals/EditTableModal";
import { subAdminListDataApiEndPoint } from "../../apis/apis";
// icons
import AddEditUserModal from "../../Modals/AddEditUserModal";
import AreYouSureModal from "../../Modals/AreYouSureModal";
import DataTable from "@/components/NewTable";
import { columns } from "./Columns";
import useUrlParams from "@/hooks/useUrlParams";
import { useGet } from "@/apiHooks/HttpFunctions";
import { PER_PAGE } from "@/constant/constants";
import { useCallback, useState } from "react";
import { useModalConfirmation } from "@/context/ModalConfirmationContext";
import { CONFIRMATION_MODAL_TYPES } from "@/Modals/NewConfirmationModal/constants";

export default function AdminUserList() {
  const params = useUrlParams();
  const { openModalConfirmation } = useModalConfirmation();

  const handleModalAction = useCallback(
    (type, data) => {
      openModalConfirmation({
        type,
        title: data?.first_name,
        id: data?.id,
        apiURL: subAdminListDataApiEndPoint,
      });
    },
    [openModalConfirmation, subAdminListDataApiEndPoint]
  );

  const handleOnClickDelete = (data) =>
    handleModalAction(CONFIRMATION_MODAL_TYPES.DELETE, data);

  const { data: listData, isPending: listIsPending } = useGet({
    apiURL: subAdminListDataApiEndPoint,
    params: {
      page: params.page || 1,
      "filter[keyword]": params["filter[keyword]"] ?? "",
      perPage: params.perPage || PER_PAGE,
    },
  });

  return (
    <>
      <DataTable
        data={listData}
        columns={columns(handleOnClickDelete)}
        isLoading={listIsPending}
        searchKey="filter[keyword]"
        editTableData={{
          onClick: () => {
            console.log("EDIT BUTTON CLICKED");
          },
        }}
        addData={{
          onClick: () => {
            console.log("ADD BUTTON CLICKED");
          },
        }}
        exportData={{
          api: subAdminListDataApiEndPoint,
          label: "Admin User List",
        }}
      />
      {/* modals */}
      {/* {show === "editTable" && (
        <EditTableModal
          handleTableHeadings={handleTableHeadings}
          setShow={setShow}
          show={show === "editTable"}
          loading={loading === "tableHeadings"}
          title={"Edit Table"}
          selectedColumn={selectedSubAdminColumns}
          allColumns={subAdminColumns}
        />
      )} */}
      {/* {(show === "confirmStatus" || show === "deleteUser") && (
        <AreYouSureModal
          setShow={setShow}
          show={show === "confirmStatus" || show === "deleteUser"}
          title={`Are you sure you want to ${
            show === "deleteUser"
              ? "delete"
              : selectedItem?.status == "active"
              ? "deactivate"
              : "reactivate"
          } user `}
          userName={`${selectedItem?.first_name} ${selectedItem?.last_name}?`}
          onClick={
            show === "deleteUser" ? handleDeleteUser : handleActivateDeactivate
          }
          isApiCall={loading === "updateStatus" || loading === "deleteUser"}
        />
      )}
      {(show === "addUser" || show === "editUser") && (
        <AddEditUserModal
          title={`${show == "addUser" ? "Add" : "Edit"} Admin User`}
          setShow={(e) => {
            setShow(e);
            setSelectedItem(null);
          }}
          show={
            (show == "editUser" || show == "addUser") &&
            allUserRoles?.length > 0
          }
          handleUserData={HandleAddOrEditSubadmin}
          data={selectedItem}
          userRolesArray={allUserRoles}
          loading={loading === "addOrEdit"}
        />
      )}
       */}
    </>
  );
}
